import { getServices, postService } from './util';

export const FETCH_SERVICES_DATA_REQUEST = 'fetchServicesDataRequest';
export const FETCH_SERVICES_DATA_SUCCESS = 'fetchServicesDataSuccess';
export const FETCH_SERVICES_DATA_ERROR = 'fetchServicesDataError';

export const CREATE_SERVICE_REQUEST = 'createServiceRequest';
export const CREATE_SERVICE_SUCCESS = 'createServiceSuccess';
export const CREATE_SERVICE_ERROR = 'createServiceError';

function fetchRequest() {
  return {
    type: FETCH_SERVICES_DATA_REQUEST
  };
}

function fetchSuccess(services) {
  return {
    type: FETCH_SERVICES_DATA_SUCCESS,
    payload: { services }
  };
}

function fetchError(error) {
  return {
    type: FETCH_SERVICES_DATA_ERROR,
    payload: error
  };
}

export function fetchServicesData() {
  return async (dispatch) => {
    try {
      dispatch(fetchRequest());

      const { data: servicesData } = await getServices();
      const { services } = servicesData;

      dispatch(fetchSuccess(services));
    } catch (error) {
      console.error(error);
      dispatch(fetchError(error));
    }
  };
}

function createRequest() {
  return {
    type: CREATE_SERVICE_REQUEST
  };
}

function createSuccess(service) {
  return {
    type: CREATE_SERVICE_SUCCESS,
    payload: service
  };
}

function createError(error) {
  return {
    type: CREATE_SERVICE_ERROR,
    payload: error
  };
}

export function createService(serviceName, escalationPolicyId) {
  return async (dispatch) => {
    try {
      dispatch(createRequest());

      const result = await postService(serviceName, escalationPolicyId);

      if (result.status === 201) {
        dispatch(createSuccess(result.data.service));
      } else {
        const message = (result.data.error && result.data.error.message) || 'Unknown error';
        throw new Error(`Failed to create a new service: ${message}`);
      }
    } catch (error) {
      console.error(error);
      dispatch(createError(error));
    }
  };
}
